import * as Sentry from '@sentry/browser';

// Ensure compatibility with older browsers (like IE11).
import 'promise-polyfill/src/polyfill';

import { Foundation } from 'foundation-sites/js/foundation.core';
import { Toggler } from 'foundation-sites/js/foundation.toggler';
import { Accordion } from 'foundation-sites/js/foundation.accordion';

import applyTextSizeClickHandler from './textsize';
import loadAsyncModules from './async';

const sentryEnv = document.body.dataset.sentryEnvironment;

if (sentryEnv) {
  Sentry.init({
    dsn: document.body.dataset.sentryDsn,
    environment: sentryEnv,
    release: document.body.dataset.sentryRelease,
    whitelistUrls: [/\.freitag\.de/, /\.fcio\.net/]
  });
}

window.Foundation.addToJquery($);
Foundation.plugin(Toggler, 'Toggler');
Foundation.plugin(Accordion, 'Accordion');

$(document).ready(() => {
  loadAsyncModules();
  $(document).foundation();
  applyTextSizeClickHandler();
});
